export default {
    create : {title : "📖 Create a new Dataset", send : "Create"},
    update : {title : "📖 Update your Dataset",  send : "Update"}
}